import { FeatureToggleClientService } from 'feature-toggle-client';
const permissionGroupsIsEnabledToggle = 'portal-fragment-permission-groups-is-enabled';
export class PermissionGroupsFeatures {
    static async isPermissionGroupsEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(permissionGroupsIsEnabledToggle);
    }
}
